import React from 'react'

const ShapeAnimation = () => {
    return (
        <>
            <div className="shape1">
                <img src="assets/img/shape1.webp" alt="shape" loading="lazy" />
            </div>
            <div className="shape2 rotateme">
                <img src="assets/img/shape2.svg" alt="shape" loading="lazy" />
            </div>
            <div className="shape4">
                <img src="assets/img/shape4.svg" alt="shape" loading="lazy" />
            </div>
            <div className="shape5">
                <img src="assets/img/shape5.webp" alt="shape" loading="lazy" />
            </div>
            <div className="shape6 rotateme">
                <img src="assets/img/shape4.svg" alt="shape" loading="lazy" />
            </div>
            <div className="shape7">
                <img src="assets/img/shape4.svg" alt="shape" loading="lazy" />
            </div>
            <div className="shape8 rotateme">
                <img src="assets/img/shape2.svg" alt="shape" loading="lazy" />
            </div>
        </>
    )
}

export default ShapeAnimation